import { FC, useEffect, useMemo, useRef, useState } from "react";
import {
  Button,
  DatePicker,
  Divider,
  Form,
  Radio,
  Typography,
} from "antd";
import moment from "moment";
import { useForm } from "antd/es/form/Form";
import {
  CommentDrawerContentApprovalForm,
  CommentFullEngineerInfoContainer,
} from "./styled";
import { CommentFullEngineerInfo } from "./CommentFullEngineerInfo";
import { ContentWrapper } from "../styled";
import {
  ECommentApproveProcessAction,
  ECommentTypeAgreement,
  TCommentApproveProcessDetails,
  TCommentData,
  TCommentStartApproveProcessPayload,
} from "../../../types";
import { FooterButtonRow, StyledTextArea } from "../InWorkCommentDrawer/styled";
import { FormTextWrapper } from "../../../components/Form";
import { commentsTabs } from "../../../constants";
// import {
//   dropCommentApproveProcess,
//   getCommentApproveDetails,
//   startCommentApproveProcess,
// } from "services";
import { sendSuccessMessage } from "../../../utils";

const actionOptions = [
  {
    label: "Создать заявку на ИЗМ",
    value: ECommentApproveProcessAction.EDIT_REQUEST,
  },
  {
    label: "Отклонить",
    value: ECommentApproveProcessAction.REJECT,
  },
];

const typeAgreementOptions = [
  {
    label: "ИЗМ 1 – ошибка проектирования",
    value: ECommentTypeAgreement.DESIGN_ERROR,
  },
  {
    label: "ИЗМ 2 – дополнительное требование",
    value: ECommentTypeAgreement.ADDITIONAL_REQUIREMENT,
  },
  {
    label: "Лист АН – уточнение решений, не отражённых в РД",
    value: ECommentTypeAgreement.CLARIFICATION_DECISIONS,
  },
];

interface IApprovalCommentDrawerProps {
  comment: TCommentData;
  onClose: () => void;
  refreshComments: () => void;
  refreshComment: () => void;
  setStep: (value: number) => void;
}

export const ApprovalCommentDrawer: FC<IApprovalCommentDrawerProps> = ({
  comment,
  onClose,
  refreshComments,
  refreshComment,
  setStep,
}) => {
  const [form] = useForm();
  const [actionState, setDecisionState] = useState<string>("");
  const [commentApproveDetails, setCommentApproveDetails] =
    useState<TCommentApproveProcessDetails | null>(null);
  const action = useRef<null | ECommentApproveProcessAction>(null);
  const savedIsApprovedByAll = useRef<boolean>(false);

  const isApprovedByAll = useMemo(() => {
    const isApproved = commentApproveDetails
      ? commentApproveDetails.responsible.every((el) => el.status !== "wait")
      : false;

    savedIsApprovedByAll.current = isApproved;

    return isApproved;
  }, [commentApproveDetails]);

  const isHaveEngineersWithStatuses =
    !!commentApproveDetails?.responsible.length;
  const isHaveEngineers = !!comment?.responsibleEngineers?.length;

  const startCommentsApprovalProcess = async (
    values: TCommentStartApproveProcessPayload
  ) => {
    const response = true
      // await startCommentApproveProcess(comment.id, values);

    if (response) {
      refreshComment();
    }
  };

  const handleDropApproveProcess = async () => {
    const response = true
      // await dropCommentApproveProcess(comment.id);

    if (response) {
      refreshComment();
    }
  };

  const handleSubmit = () => {
  //   form
  //     .validateFields()
  //     .then((values) => startCommentsApprovalProcess(values))
  //     .catch((info) => console.error("Validate Failed:", info));
  };

  useEffect(
    () => () => {
      if (savedIsApprovedByAll.current) {
        refreshComments();
        sendSuccessMessage(
          `Решение по замечанию ${
            comment.number
          } принято \nЗамечание перемещено в раздел «${
            commentsTabs[
              action.current === ECommentApproveProcessAction.REJECT ? 2 : 3
            ]
          }»`
        );
      }
    },
    []
  );

  // useEffect(() => {
  //   if (comment.startAgreement) {
  //     (async () => {
  //       const response = await getCommentApproveDetails(comment.id);

  //       if (response) {
  //         setCommentApproveDetails(response);
  //         action.current = response.agreement.action;

  //         setDecisionState(response.agreement.action);
  //         form.setFieldsValue({
  //           action: response.agreement.action ?? "",
  //           exceptedDate: moment(response.agreement.exceptedDate) ?? "",
  //           descriptionAgreement: response.agreement.descriptionAgreement ?? "",
  //           typeAgreement: response.agreement.typeAgreement ?? "",
  //         });
  //       }
  //     })();
  //   } else {
  //     setCommentApproveDetails(null);
  //     action.current = null;
  //   }
  // }, [comment]);

  return (
    <CommentDrawerContentApprovalForm
      form={form}
      data-testid="approval-comment-decision-form"
      name="approval-comment-decision-form"
      initialValues={{
        action: "",
        exceptedDate: "",
        descriptionAgreement: "",
        typeAgreement: "",
      }}
      onSubmitCapture={handleSubmit}
      validateMessages={{ required: "Обязательно для заполнения" }}
    >
      <div className="content-decision-wrapper">
        <ContentWrapper>
          <Typography.Title level={5}>Согласование</Typography.Title>

          <Form.Item
            label="Действие после согласования"
            name="action"
            rules={[
              {
                required: true,
                transform: (value) => value.toString(),
              },
            ]}
          >
            <Radio.Group
              disabled={!!comment.startAgreement}
              options={actionOptions}
              onChange={(e: any) => setDecisionState(e.target.value)}
            />
          </Form.Item>

          {actionState === actionOptions[0].value && (
            <>
              <Form.Item
                label="Ожидаемая дата исполнения"
                name="exceptedDate"
                rules={[
                  {
                    required: true,
                    transform: (value) => value.toString(),
                  },
                ]}
              >
                <DatePicker
                  allowClear={false}
                  disabled={!!comment.startAgreement}
                  placeholder="Выберите дату"
                  disabledDate={(date: any) => moment(date).isBefore(moment())}
                />
              </Form.Item>

              <Form.Item
                label="Тип"
                name="typeAgreement"
                rules={[
                  {
                    required: true,
                    transform: (value) => value.toString(),
                  },
                ]}
              >
                <Radio.Group
                  disabled={!!comment.startAgreement}
                  options={typeAgreementOptions}
                />
              </Form.Item>

              <FormTextWrapper
                label="Описание решения"
                maxLength={512}
                name="descriptionAgreement"
                required
              >
                <StyledTextArea
                  disabled={!!comment.startAgreement}
                  placeholder="Например,"
                  rows={3}
                />
              </FormTextWrapper>
            </>
          )}

          {actionState === actionOptions[1].value && (
            <FormTextWrapper
              label="Причина отклонения"
              maxLength={512}
              name="descriptionAgreement"
              required
            >
              <StyledTextArea
                disabled={!!comment.startAgreement}
                placeholder="Например,"
                rows={3}
              />
            </FormTextWrapper>
          )}

          {(isHaveEngineersWithStatuses || isHaveEngineers) && (
            <>
              <Divider />

              <CommentFullEngineerInfoContainer>
                {isHaveEngineersWithStatuses &&
                  commentApproveDetails.responsible.map((el) => (
                    <CommentFullEngineerInfo
                      canApprove={el.canApprove}
                      commentId={comment.id}
                      engineer={el}
                      refreshComment={refreshComment}
                      status={el.status}
                      key={el.id}
                    />
                  ))}

                {!isHaveEngineersWithStatuses &&
                  isHaveEngineers &&
                  comment?.responsibleEngineers
                    ?.filter((el) => el.userId !== comment.responsibleId)
                    .map((el) => (
                      <CommentFullEngineerInfo engineer={el} key={el.id} />
                    ))}
              </CommentFullEngineerInfoContainer>
            </>
          )}
        </ContentWrapper>

        <FooterButtonRow justify="space-between">
          {isApprovedByAll && (
            <Button
              style={{ marginLeft: "auto" }}
              onClick={onClose}
              type="primary"
            >
              Закрыть
            </Button>
          )}

          {!isApprovedByAll && (
            <>
              <Button onClick={() => setStep(1)}>Назад</Button>

              {!!comment.startAgreement ? (
                <Button danger onClick={handleDropApproveProcess} type="ghost">
                  Сбросить согласование
                </Button>
              ) : (
                <Button htmlType="submit" type="primary">
                  Начать согласование
                </Button>
              )}
            </>
          )}
        </FooterButtonRow>
      </div>
    </CommentDrawerContentApprovalForm>
  );
};
